/**
 * iconClass: Button's class name    string
 *     options: "icon_excel", ""
 * style: Button's style    object
 * name: Button's name    string
 * onClick: Button's click event    function
 * disabled: Button's disabled    boolean
 * icon: Button's icon    component
 * iconSize: Button icons's size    string
 *
 */

import React from "react";
/** fontAwesome Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function IconButton({
	iconClass,
	style,
	name,
	onClick,
	disabled,
	icon,
	iconSize,
}) {
	const ButtonPress = () => {
		onClick();
	};

	return (
		<button
			className="btn st01 with_icon"
			style={style}
			onClick={ButtonPress}
			disabled={disabled}
		>
			{iconClass === "icon_excel" ? (
				<div
					className={
						iconClass === "icon_excel" ? "icon_excel" : iconClass
					}
				/>
			) : (
				<FontAwesomeIcon
					icon={icon}
					style={{
						marginLeft: "-22px",
						marginRight: "5px",
						padding: 0,
						fontSize: iconSize,
					}}
				/>
			)}
			{name}
		</button>
	);
}

IconButton.defaultProps = {
	iconClass: "icon_excel",
};

export default IconButton;
